import { Grid, useMediaQuery, useTheme } from '@mui/material';

import { HouseholdEstimatedTaxSavings } from '@/modules/household/HouseholdEstimatedTaxSavings';
import { HouseholdTaxForWaterfall } from '@/modules/household/HouseholdTaxForWaterfall/HouseholdTaxForWaterfall';
import { useTenantDetailsContext } from '@/modules/tenant/TenantDetailsContext/TenantDetailsContext';

import { ClientDeliverableOptions } from './ClientDeliverableOptions';
import { ClientDetailsOverviewPageCard } from './ClientDetailsOverviewPageCard';
import { useClientDetailsOverviewPageQuery } from './hooks/useClientDetailsOverviewPageQuery';

interface ProjectionContentSectionProps {
  householdId: string;
  household: ReturnType<typeof useClientDetailsOverviewPageQuery>['household'];
}

export function ProjectionContentSection({
  householdId,
  household,
}: ProjectionContentSectionProps) {
  const { projectionFunctionalityEnabled } = useTenantDetailsContext();
  const theme = useTheme();
  const isLargeOrLess = useMediaQuery(theme.breakpoints.down('lg'));

  // Case 1: Projection functionality is enabled - show normal components
  if (projectionFunctionalityEnabled) {
    return (
      <>
        <Grid item gridArea="estate-tax">
          <ClientDetailsOverviewPageCard includeHelpContentTrigger>
            <HouseholdTaxForWaterfall
              // Make this component reinitialize when the householdId changes
              key={householdId}
              householdId={householdId}
            />
          </ClientDetailsOverviewPageCard>
        </Grid>
        <Grid item gridArea="tax-savings">
          <ClientDetailsOverviewPageCard includeHelpContentTrigger>
            <HouseholdEstimatedTaxSavings
              impliedEstateTaxSavings={
                household?.clientPerformanceReport.impliedEstateTaxSavings
              }
              wealthTransferred={
                household?.clientPerformanceReport.totalWealthTransferred
              }
              householdId={householdId}
            />
          </ClientDetailsOverviewPageCard>
        </Grid>
      </>
    );
  }

  return (
    <Grid
      item
      sx={{
        gridArea: 'estate-tax / estate-tax / tax-savings / tax-savings',
      }}
    >
      <ClientDeliverableOptions
        direction={isLargeOrLess ? 'column' : 'row'}
        householdId={householdId}
      />
    </Grid>
  );
}
